import { useEffect, useMemo } from 'react';
import { translations } from './translations';

// Base path the app is deployed under ("/new" now, "" if moved to root).
const BASE = process.env.PUBLIC_URL || '';

const getLanguageFromPath = () => {
  const path = window.location.pathname;
  if (/\/en(\/|$)/.test(path)) return 'en';
  if (/\/ua(\/|$)/.test(path)) return 'ua';
  return 'ru';
};

const urlForLanguage = (lang) => {
  if (lang === 'ua') return `${BASE}/ua/`;
  if (lang === 'en') return `${BASE}/en/`;
  return `${BASE}/`;
};

export const useLanguage = () => {
  // Language is derived from the URL so every language is a real, indexable page.
  const language = getLanguageFromPath();

  useEffect(() => {
    document.documentElement.lang = language === 'ua' ? 'uk' : language;
  }, [language]);

  const setLanguage = (nextLanguage) => {
    if (nextLanguage !== language) {
      window.location.assign(urlForLanguage(nextLanguage));
    }
  };

  const t = useMemo(
    () => (path) => path.split('.').reduce((value, key) => value?.[key], translations[language]),
    [language],
  );

  return { language, setLanguage, t };
};
